<template>
	<div class="subnet-detail w-content" style="padding-top: 120px;" >
		<div class="ch-title">
			<div class="ch-title-top">
				<img src="../../assets/dataCenter/subnet-t.png" alt="" class="ch-title__icon">
				<span class="ch-title__text">子网</span>
			</div>
			<div class="ch-title-bottom">
				{{id}}
			</div>
		</div>
		<div class="ch-content">
			<div class="ch-bar">
				<div class="ch-bar-title">子网详细资料</div>
			</div>
			<subnet-list :state="state"></subnet-list>
		</div>
		<div class="ch-table">
			<el-table :data="tableData" style="width: 100%">
				<el-table-column label="节点" prop="send" min-width="200">
					<template slot-scope="{row}">
						<span class="t-ellipsis">
							{{row.id}}
						</span>
					</template>
				</el-table-column>
				<el-table-column label="操作员" prop="send" min-width="200">
					<template slot-scope="{row}">
						<span class="t-ellipsis">
							{{row.operator.id}}
						</span>
					</template>
				</el-table-column>
				<el-table-column label="提供者" prop="send" min-width="200">
					<template slot-scope="{row}">
						<span class="t-ellipsis">
							{{row.provider.id}}
						</span>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="ch-page">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:page-sizes="[100, 200, 300, 400]" :page-size="1"
				layout=" prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
import subnetList from './list/subnetList.vue'
import {serchSubnets} from '../../serve/request'
export default {
	props: ['id'],
	components: {
		subnetList
	},
	data() {
		return {
			tableData: [],
			page: 0,
			total: 0,
			minute: 1000 * 60,
			hour: 1000 * 60 * 60,
			day: 1000 * 60 * 60 * 24,
            state:{type: '',
                nodes: 0,
                uniqueOperators: 0,
                uniqueProviders: 0,
                totalCanisters: 0}
		}
	},
	watch: {
		$route(to, from) {
			this.$router.go(0)
		}
	},
	methods: {
		handleSizeChange() {},
		handleCurrentChange(val) {
			this.page = val - 1
			this.loadTransactionAccount()
		},
		loadTransactionAccount() {
            serchSubnets(this.id).then(res=>{
                this.tableData=res.nodes;
                this.state.type = res.subnetType;
                this.state.nodes = res.nodeCount;
                this.state.totalCanisters =res.canisterCount;
                let operator = new Map();
                let provider = new Map();
                res.nodes.forEach(item=>{
                    if (!operator.has(item.operator.id)){
                        operator.set(item.operator.id,item.operator.id)
                    }
                    if (!provider.has(item.provider.id)){
                        provider.set(item.provider.id,item.provider.id)
                    }
                })
                debugger
                this.state.uniqueOperators = operator.size
                this.state.uniqueProviders = provider.size
            })
        },
	},
	created() {
		this.page = 0
		this.loadTransactionAccount()
	}
}
</script>

<style lang="scss" scoped>
.ch-bar {
	height: 40px;
	line-height: 40px;
	background: rgba(35, 0, 77, 0.1);
	margin: 0 -64px;
	.ch-bar-title {
		padding-left: 100px;
		font-size: 20px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #23004d;
	}
}
</style>
